export const HISTORY_ACTIONS = {
  push: 'PUSH',
  replace: 'REPLACE',
  pop: 'POP',
};
